import EyeOpen from "../Assets/LoginPage/EyeOpen.svg";
import LoginMainImg from "../Assets/LoginPage/LoginMainImg.svg";
import EyeClose from "../Assets/LoginPage/EyeClose.svg";
import Lock from "../Assets/LoginPage/Lock.svg";
import Mail from "../Assets/LoginPage/Mail.svg";
import { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setUserInfo } from "../ReduxStore/App/auth.slice";
import { setMyIndex } from "../ReduxStore/App/DashBoard/dashboardSlice";
import { userLogin } from "../api/User";
import toast from "react-hot-toast";
import WeatherSnap_Logo from "../Assets/WelcomeScreen/WeatherSnap_Logo.png";
import niruthWhitelogo from '../Assets/WelcomeScreen/niruthWhitelogo.svg'
import niruthBlacklogo from '../Assets/WelcomeScreen/niruthBlacklogo.svg'

function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [showPsw, setShowPsw] = useState(false);
  const [loginValue, setLoginValue] = useState({ email: "", password: "" });
  const [errors, setErrors] = useState({ email: "", password: "" });

  const previousPath = location.state;
  const { isAuth, loading } = useSelector((store) => store.auth);
  const { previousPage, theme } = useSelector((store) => store.dashboard);

  const { email, password } = loginValue;

  const validate = () => {
    let isValid = true;
    const newErrors = { email: "", password: "" };

    if (!email.trim()) {
      isValid = false;
      newErrors.email = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      isValid = false;
      newErrors.email = "Invalid email format.";
    }

    if (!password.trim()) {
      isValid = false;
      newErrors.password = "Password is required.";
    } else if (password.length < 6) {
      isValid = false;
      newErrors.password = "Password must be at least 6 characters.";
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleLogin = (e) => {
    const { name, value } = e.target;
    setLoginValue((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) {
      return;
    }

    try {
      const result = await userLogin(loginValue);
      const { success, message, user } = result;

      if (success) {
        toast.success("Login successful!");
        dispatch(setUserInfo(user))
        if (previousPath === "/near-realtime-data") dispatch(setMyIndex(1));
        if (previousPath === "/historical-data") dispatch(setMyIndex(2));

        navigate(previousPage || "/dashboard");

      } else {
        toast.error(message || "Login failed.");
      }
    } catch (error) {
      toast.error(error?.message || "An error occurred while logging in.");
    }
  };



  if (loading) {
    return null;
  }

  if (isAuth) {
    navigate("/dashboard");
    return null;
  }

  return (
    <>
      <div className="sm:flex sm:flex-col sm:justify-between sm:p-2   lg:grid lg:grid-cols-2 lg:grid-rows-12 lg:items-center    h-screen bg-primaryBgColor dark:bg-darkModePrimaryBgColor  ">
        <div className="text-blackPrimaryText sm:flex-grow sm:flex sm:flex-col sm:justify-center sm:items-center dark:text-darkModeBlackPrimaryText     lg:row-span-11 lg:grid lg:grid-rows-3 lg:items-center lg:justify-center    ">
          <div className="sm:flex py-4 sm:justify-center lg:grid">
            <img
              width={"200px"}
              src={WeatherSnap_Logo}
              alt="WeatherSnap_Logo"
            />
          </div>

          <form onSubmit={handleSubmit} className="flex flex-col gap-4 sm:w-[80%] lg:min-w-[400px]">
            <div>
              <div className="flex gap-2 py-2 px-1 lg:py-2 lg:px-3 bg-white dark:bg-darkModeCardBgColor border border-gray-300 dark:border-white/10 rounded-md focus-within:border-wsText dark:focus-within:border-white/50 transition-colors">
                <img src={Mail} alt="Mail" className="dark:invert" />
                <input
                  className="outline-none text-black dark:text-darkModeBlackPrimaryText flex-1 bg-transparent text-lg "
                  type="email"
                  placeholder="Email Address"
                  value={email}
                  name="email"
                  onChange={handleLogin}
                />
              </div>
              <div>
                {errors.email && (
                  <p className="text-orange-600 font-semibold  italic text-sm">
                    {errors.email}
                  </p>
                )}
              </div>
            </div>
            <div>
              <div className="flex gap-2 py-2 px-1 lg:py-2 lg:px-3 bg-white dark:bg-darkModeCardBgColor border border-gray-300 dark:border-white/10 rounded-md focus-within:border-wsText dark:focus-within:border-white/50 transition-colors">
                <img width="24px" src={Lock} alt="Lock" className="dark:invert" />
                <input
                  className="outline-none text-black dark:text-darkModeBlackPrimaryText flex-1 bg-transparent text-xl"
                  type={!showPsw ? "password" : "text"}
                  placeholder="Password"
                  value={password}
                  name="password"
                  onChange={handleLogin}
                />
                <img
                  width="24px"
                  onClick={() => setShowPsw(!showPsw)}
                  className="cursor-pointer dark:invert"
                  src={!showPsw ? EyeClose : EyeOpen}
                  alt="Toggle visibility"
                />
              </div>

              <div>
                {errors.password && (
                  <p className="text-orange-600 font-semibold  italic text-sm">
                    {errors.password}
                  </p>
                )}
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 justify-between mt-2">
              <button className="cursor-pointer text-white bg-wsText hover:bg-opacity-95 font-bold rounded-lg px-6 py-2.5 text-lg shadow-md hover:shadow-lg transition-all duration-150 text-center" type="submit">
                Login
              </button>
              <Link to="/dashboard" className="flex-1">
                <div
                  tabIndex={0}
                  onClick={() => dispatch(setMyIndex(0))}
                  className="cursor-pointer text-blackPrimaryText dark:text-darkModeBlackPrimaryText hover:bg-slate-50 dark:hover:bg-slate-800 border border-gray-300 dark:border-gray-700 font-bold rounded-lg px-6 py-2.5 text-lg shadow-sm hover:shadow-md transition-all duration-150 text-center"
                >
                  Continue without Login
                </div>
              </Link>
            </div>
          </form>
        </div >
        <div className="sm:hidden  lg:flex justify-center lg:row-span-11">
          <img width={"80%"} src={LoginMainImg} alt="Login Illustration" />
        </div>

        <div className="sm:flex sm:items-end sm:justify-center sm:gap-2 lg:flex lg:justify-center lg:gap-2 lg:items-end    ">
          <div className="flex items-center gap-2 justify-center ">
            <p className="font-bold text-blackPrimaryText dark:text-darkModeBlackPrimaryText">
              A Product of
            </p>

            <img
              className="lg:w-[70px] sm:w-[80px] pb-4"
              src={theme === "dark" ? niruthWhitelogo : niruthBlacklogo}
              alt="WeatherSnap_Logo"
            />
          </div>
        </div>
      </div >
    </>
  );
}

export default LoginPage;